module.exports = __webpack_public_path__ + "img/desteban.b1458576.png";